export default {
  getSearchedStudentHistory: (state) => state.studentSearchHistory,
  getSearchOpened: (state) => state.searchOpened,
  getWebServiceStudentSearchEnabled: (state) =>
    state.webServiceStudentSearchEnabled,
  getShowFastSearch: (state) => state.showFastSearch,
  getShowTapRequestAlert: (state) => state.showTapRequestAlert,
  getIsSearchStudentOpenedFromOutside: (state) =>
    state.isSearchStudentOpenedFromOutside,
};
